module.exports = __webpack_public_path__ + "img/img_customer_banner.c1744e7f.png";